import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/moneybird.webp';
import screenshot_target from '../../../images/letterfunnel/edwinvlieg.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Edwin Vlieg"
      firstname="Edwin"
      companyname="Moneybird"
      competition="e-Boekhouden.nl en Jortt"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/edwinvlieg.js